module.exports = __webpack_public_path__ + "static/media/logo_180х200.7d44ebb4.png";